import { ManyProviderColumnsTypes } from "components/Modals/StepRegister/StepRegisterManyProvider/data";
import { IProviderCreateProps } from "interfaces/Provider";

export type XlsxData = { [key in ManyProviderColumnsTypes]: string };

class CreateManyProviderAdapter {
  adapt(xlsxData: XlsxData[]): IProviderCreateProps[] {
    return xlsxData.map((xlsxRow) => {
      const baseObject: IProviderCreateProps = {
        email: xlsxRow["email_do_fornecedor"],
        name: xlsxRow["nome_do_fornecedor"],
        password: xlsxRow["senha_do_fornecedor"],
        managerName: xlsxRow["nome_do_representante_do_fornecedor"],
        tradingName: xlsxRow["nome_fantasia_do_fornecedor"],
      } as IProviderCreateProps

      const haveCnpj = xlsxRow["cnpj_do_fornecedor"];
      if (xlsxRow.nome_do_fornecedor === undefined){
        return baseObject;
      }
      if (!haveCnpj) {
        baseObject.rg = xlsxRow["rg_do_fornecedor"].replace(
          /[-.,/#!$%^&*;:{}=\-_`~()]/g,
          ""
        );
        baseObject.cpf = xlsxRow["cpf_do_fornecedor"].replace(
          /[-.,/#!$%^&*;:{}=\-_`~()]/g,
          ""
        );
      } else {
        console.log('else')
        baseObject.cnpj = xlsxRow["cnpj_do_fornecedor"].replace(
          /[-.,/#!$%^&*;:{}=\-_`~()]/g,
          ""
        );
      }
      return baseObject;
    });
  }
}

export const createManyProviderAdapter = new CreateManyProviderAdapter();
